import { useRef } from "react";
import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "./ui/carousel";

const arrowClass =
  "hidden h-9 w-9 border-[rgba(201,162,75,0.5)] bg-[#111110]/90 text-[#e6c87a] hover:bg-[#c9a24b] hover:text-[#0a0a09] sm:flex";

export const RepairCarousel = ({ images, testId = "repair-carousel" }) => {
  const plugin = useRef(Autoplay({ delay: 4000, stopOnInteraction: true }));

  return (
    <Carousel
      opts={{ loop: true, align: "start" }}
      plugins={[plugin.current]}
      className="relative"
      data-testid={testId}
    >
      <CarouselContent>
        {images.map((img, i) => (
          <CarouselItem
            key={img.src}
            className="sm:basis-1/2 lg:basis-1/3"
            data-testid={`${testId}-item-${i + 1}`}
          >
            <div className="aspect-[4/3] overflow-hidden border border-[rgba(201,162,75,0.25)] bg-[#0e0d0c]">
              <img
                src={img.src}
                alt={img.alt}
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious data-testid={`${testId}-prev`} className={`left-2 top-1/2 -translate-y-1/2 ${arrowClass}`} />
      <CarouselNext data-testid={`${testId}-next`} className={`right-2 top-1/2 -translate-y-1/2 ${arrowClass}`} />
    </Carousel>
  );
};
